import axios from '@/utils/api'

const actions = {

  async hasEditalVigente (context) {
    const data = await axios({
      method: 'GET',
      url: `publico/edital/hasEditalVigente`
    })

    return data
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/credenciado/credenciado.js